<template>
  <v-card class="info-page rounded-xl bg-surface border border-white-05 pa-8 mb-10 text-body-1">
    <div class="text-h3 font-weight-black mb-6 text-primary">Terms of Service</div>
    
    <div class="text-h5 font-weight-bold mb-4">1. Acceptance of Terms</div>
    <p class="text-grey-lighten-1 mb-6">
      By accessing Gamedev.id, you agree to comply with these terms. As we are built on the AT Protocol, you are also subject to the community guidelines and terms set forth by your PDS (Personal Data Server) provider.
    </p>

    <div class="text-h5 font-weight-bold mb-4">2. Community Standards</div>
    <p class="text-grey-lighten-1 mb-6">
      Gamedev.id is a professional community. We expect users to maintain a respectful environment. Harassment, hate speech, and illegal content are strictly prohibited and may result in blocking or filtering from this client.
    </p>

    <div class="text-h5 font-weight-bold mb-4">3. Data Ownership</div>
    <p class="text-grey-lighten-1 mb-6">
      You own your content. Gamedev.id does not claim ownership of any data you post via the AT Protocol. Your data is decentralized and can be moved between clients at your discretion.
    </p>

    <div class="text-h5 font-weight-bold mb-4">4. Disclaimer</div>
    <p class="text-grey-lighten-1 mb-6">
      Gamedev.id is provided "as is" without warranty of any kind. We are not responsible for the content posted by users or any issues arising from the underlying AT Protocol infrastructure.
    </p>

    <div class="mt-10">
      <v-btn color="primary" variant="tonal" rounded="pill" class="text-none font-weight-black px-6" @click="$emit('back')">
        I Understand, Take Me Back
      </v-btn>
    </div>
  </v-card>
</template>

<script setup lang="ts">
defineEmits(['back']);
</script>

<style scoped>
.info-page {
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}
</style>
